<template>
    <div id="Dashboard">
        <h1>Dashboard</h1>
        
        <p class="centered" v-if="!dataLoaded">
            <router-link to="/myaccount">Login</router-link> to Access the MPL CRM
        </p>

        <div class="row" v-if="dataLoaded">
            <div class="column shadowed">
                <h3>To-Dos</h3>
                <ul>
                    <li v-for="todo in todos" :key="todo.id">
                        <p>
                            <router-link :to="'/projects/'+todo.project">Project {{todo.project}}</router-link>
                            : <b>{{todo.typeName}}</b>, due {{todo.due_date | date}} </p>
                        <p>{{todo.content | truncate(40)}}</p>
                    </li>
                </ul>
            </div>

            <div class="column shadowed" id="contactList">
                <h3>My Customers</h3>
                <ul>
                    <li v-for="c in customers" :key="c.id">
                        <router-link :to="'/customers/'+c.id">{{c.name | truncate(20)}}</router-link>({{c.numProjects}} projects)</li>
                </ul>
            </div>

            <div class="column shadowed">
                <h3>Completed In Last 7 Days</h3>
                <ul>
                    <li v-for="c in completed" :key="c.name">{{c.numCompleted}} {{c.name | truncate(40)}}</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    // Import Helpers
    import {CallApi} from '../Utilities.js'

    // Module Code
    export default {
        data:  function () {
            return {
                dataLoaded :false,
                todos: [],
                customers: [],
                completed: []
            }
        },
        methods: {
            refresh: async function() {
                this.rawContacts = JSON.stringify(await CallApi('GET', '/contacts'))                
            },

            fetchData: async function() {
                const allResults  =  (await CallApi('GET', '/dashboard'))
                this.todos = allResults.todos
                this.customers = allResults.customers
                this.completed = allResults.recentlyCompleted
                this.dataLoaded = true
            }
        },
        mounted() {
            if (this.$store.User.id) {
                this.fetchData();
            }
        }
    }
</script>